module.exports = __webpack_public_path__ + "static/img/CA.0e4f55c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certified_shipping/CA.png
// module id = Lffc
// module chunks = 2